<template>
  <div>
    <div class="white black--text">
      <app-alert @dismissed="onDismissed"  v-if="error" :text="error.message"></app-alert>
      <div class="subheading font-weight-thin">Search Contact</div>
      <v-col
          cols="6"
          sm="6"
      >
        <v-select
            :items="phoneNumbersOnlyList"
            label="From Phone number"
            dense
            outlined
            v-model="selectedPhoneNumberName"
        ></v-select>

      </v-col>
      <v-col
          cols="6"
          sm="6"
      >
        <v-menu offset-y allow-overflow>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                label="Contact Name"
                v-model="searchUser"
                placeholder="David"
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-list v-if="filteredList.length == 0">
            <v-list-item
                @click="newUserDialog = true"
            >
              <v-list-item-title>{{ searchUser }}</v-list-item-title>
            </v-list-item>
          </v-list>
          <v-list v-if="filteredList.length !== 0">
            <v-list-item
                v-for="(user, index) in filteredList"
                :key="index"
                @click="userPicked(user)"
            >
              <v-list-item-title>{{ user.name}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-dialog v-model="newUserDialog"
                ref="dialog"
                persistent
                width="290px"
      >
        <v-card>
          <v-card-title>
            <div class="white black--text text-xs-center font-weight-thin headline">Add new contact</div>
          </v-card-title>
          <v-card-text v-if="!loading">
            <v-list>
              <v-list-item>
                <v-list-item-action><v-icon>person</v-icon></v-list-item-action>
                <v-list-item-content >
                  <v-text-field
                      v-model="searchUser"
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-action><v-icon>smartphone</v-icon></v-list-item-action>
                <v-list-item-content>

                  <v-text-field
                      v-model="phoneNumber"
                  ></v-text-field>

                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-action><v-icon>email</v-icon></v-list-item-action>
                <v-list-item-content>

                  <v-text-field
                      v-model="email"
                  ></v-text-field>

                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <app-loading v-else></app-loading>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="newUserDialog = false" text>cancel</v-btn>
            <v-btn @click="createUser" class="blue white--text">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import {collection, getDocs} from "firebase/firestore";

export default {
  data () {
    return {
      searchUser: '',
      pickedUser: undefined,
      clientUser: false,
      sortedContacts: [],
      newUserDialog: false,
      phoneNumber: '+1',
      email: '',
      provisionedPhoneNumbers: undefined,
      phoneNumbersOnlyList: undefined,
      selectedPhoneNumber: '',
      selectedPhoneNumberName: ''
    }
  },
  watch: {
    selectedPhoneNumberName (value) {
      if (value !== '') {
        this.loadSMSContacts(value)
      }
    }
  },
  created () {
    let db = this.$store.state.db
    let numbersRef = getDocs(collection(db, 'users', this.user.uid + '/provisionedNumbers'))
    return numbersRef
        .then (numbers => {
          let numbersList = []
          let phoneNumbersOnly = []
          numbers.forEach (number => {
            numbersList.push(number.data())
            phoneNumbersOnly.push(number.data().friendlyName)
          })
          this.provisionedPhoneNumbers = numbersList
          this.phoneNumbersOnlyList = phoneNumbersOnly
          this.selectedPhoneNumberName = phoneNumbersOnly[0]
        })
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    filteredList () {
      if(this.sortedContacts.length !== 0) {
        return this.sortedContacts.filter((user) => {
          return user.name.toLowerCase().match(this.searchUser.toLowerCase())
        })
      } else return []
    },
    loading () {
      return this.$store.getters.loading
    },
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    numberSelected() {

    },
    loadSMSContacts (phoneNumberName) {
      let obj = this.provisionedPhoneNumbers.find(number => {
        return number.friendlyName === phoneNumberName
      })
      let phoneNumber = obj.phoneNumber
      let db = this.$store.state.db
      let smsRef = getDocs(collection(db, 'users', this.user.uid + '/provisionedNumbers/' + phoneNumber + '/sms'))
      return smsRef
          .then(contacts => {
            let numbersList = []
            contacts.forEach (number => {
              numbersList.push(number.data())
            })
            this.sortedContacts = numbersList.sort((convoA, convoB) => {
              return convoB.lastActive - convoA.lastActive
            })
          })
          .catch(err => {
            this.$store.dispatch('setError', err)
            this.$store.dispatch("setLoading", false)
            console.log(err)
          })

    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    userPicked(value) {
      this.searchUser = value.name
      this.pickedUser = value
      // console.log(value)
      this.$emit('userFound', value)
    },
    cancel() {
      this.pickedUser = undefined
      this.searchUser = ''
    },
    createUser () {
      // let userRef = this.$store.state.db.collection('users')
      let user = {
        name: this.searchUser,
        phoneNumber: this.phoneNumber,
        email: this.email
      }
      console.log(user)
      // userRef.add(user)
      //     .then(res => {
      //       user.id = res.id
      //       this.$emit('userFound', user)
      //       return userRef.doc(res.id).update(user)
      //     })
      //     .catch(err => {
      //       this.$store.dispatch('setError', err)
      //     })
    }
  }
}
</script>
